import {BaseApiTemplateService, Core2Config} from '../../shared';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {WfIssueTypeContainerModel} from "../../../../../../models/aggregates/wf/issue";

@Injectable({providedIn: 'root'})
export class WfIssueTypeBackofficeEpService extends BaseApiTemplateService<WfIssueTypeContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.DOMAIN_URL_PREFIX + Core2Config.WF_PREFIX + 'issue-types';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.WF_PREFIX + 'issue-types';
    this.httpClient = http;
  }
}
